import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

export const useRemoveTopic = (
  projectId: string,
  topicName: string,
  options: Omit<UseMutationOptions<void, ErrorResponse, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<void> => {
      await api.delete(`/projects/${projectId}/topics/${encodeURIComponent(topicName)}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "topics"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "topics", topicName],
      });
    },
    ...options
  });
};
